<template>
  <div class="input-group">
    <v-row>
      <v-col>
        <v-text-field v-model="node.name" label="Name" dense hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          v-model="property.methods"
          class="width150px"
          :items="methods"
          label="Method"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="property.url"
          label="URL"
          hide-details
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense  ===-->
        <intellisense-component
          :input="property.url"
          :drawFlowItems="drawFlowItems"
          :property="'url'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="m-t-10 pt-0 pb-0">
        <v-tabs centered fixed-tabs v-model="activeTab">
          <v-tab
            v-for="item in itemsTab"
            :id="item"
            :key="item"
            class="font-size-sub"
            @click="currentTab = item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col v-if="currentTab === 'headers'" cols="12" sm="12" md="12" lg="12">
        <fieldset class="form-group m-b-0 height200px">
          <v-row>
            <v-col cols="12" sm="5" lg="5">
              <span>Key</span>
            </v-col>
            <v-col cols="12" sm="7" lg="7" class="d-flex justify-space-between">
              <span>Value</span>
              <v-icon small @click="addHeader">fa-plus-circle</v-icon>
            </v-col>
          </v-row>
          <v-row v-for="(pair, index) in property.headers" :key="index">
            <v-col cols="12" sm="5" lg="5" class="p-t-0">
              <v-text-field
                class="margin0 padding0"
                v-model="property.headers[index].key"
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="7"
              lg="7"
              class="p-t-0 d-flex justify-space-between"
            >
              <v-text-field
                class="margin0 padding0"
                v-model="property.headers[index].value"
                hide-details
                dense
              ></v-text-field>
              <v-icon small class="ml-1" @click="deleteHeader(index)"
                >fa-trash</v-icon
              >
            </v-col>
          </v-row>
        </fieldset>
      </v-col>
      <v-col v-if="currentTab === 'body'" cols="12" sm="12" md="12" lg="12">
        <v-textarea
          class="textarea-input overflow-x"
          solo
          hide-details
          rows="7"
          v-model="property.body"
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.body"
          :drawFlowItems="drawFlowItems"
          :property="'body'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
      <v-col v-if="currentTab === 'settings'" cols="12" sm="12" md="12" lg="12">
        <fieldset class="form-group m-b-0 height200px">
          <v-row class="align-center">
            <v-col class="p-b-0" cols="12" sm="6" lg="6">
              <span>Request timeout</span>
            </v-col>
            <v-col
              class="middle d-flex align-center p-b-0"
              cols="12"
              sm="6"
              lg="6"
            >
              <div>
                <v-text-field
                  class="margin0 padding0 width70px"
                  v-model="property.setting.timeout"
                  type="number"
                  @blur="setPropertyData('timeout')"
                  hide-details
                  dense
                  reverse
                ></v-text-field>
              </div>
              <div class="ml-2">seconds</div>
            </v-col>
          </v-row>
          <v-row class="align-center">
            <v-col class="p-b-0" cols="12" sm="6" lg="6">
              <span>Wait for response</span>
            </v-col>
            <v-col
              class="middle d-flex align-center p-b-0"
              cols="12"
              sm="6"
              lg="6"
            >
              <div class="width70px">
                <v-switch
                  class="margin-left"
                  v-model="property.setting.await"
                  inset
                  dense
                  hide-details
                ></v-switch>
              </div>
            </v-col>
          </v-row>
        </fieldset>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    tabs: Array,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      methods: ['GET', 'PUT', 'POST', 'DELETE'],
      itemsTab: [],
      currentTab: 'body',
      activeTab: 1,
      //=== use for Intellisense ===-->
      isOpenIntellisense: false,
      start: -1,
      isKeyTab: false,
      eventKey: '',
      //=== use for Intellisense ===-->
      lastValueSettingTimeout: 0
    }
  },
  created() {
    this.property = this.node.property

    this.tabFilter = _.filter(
      this.tabs,
      o => o !== 'Start' && o !== 'Enter' && o !== 'Exit'
    )

    setTimeout(() => {
      this.itemsTab = ['headers', 'body', 'settings']
    }, 500)

    //ใช้เก็บ ค่าเดิมก่อนแก้ไข (last valid value)
    this.lastValueSettingTimeout = this.property.setting.timeout
  },
  methods: {
    setPropertyData(property) {
      const numberPattern = /^\d+$/
      let val = 30.0
      if (!numberPattern.test(this.property.setting[property])) {
        val = this.lastValueSettingTimeout
        this.property.setting[property] = parseFloat(val).toFixed(1)
      } else {
        val = this.property.setting[property]

        if (val < 0) {
          val = 0
        }
        this.property.setting[property] = parseFloat(val).toFixed(1)
        this.lastValueSettingTimeout = this.property.setting[property]
      }
    },
    addHeader() {
      this.property.headers.push({
        key: '',
        value: ''
      })
    },
    deleteHeader(index) {
      this.property.headers.splice(index, 1)
    },
    //=== use for Intellisense ===-->
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'url') {
        this.property.url = data
      } else if (property == 'body') {
        this.property.body = data
      }
    }
    //=== use for Intellisense ===-->
  }
}
</script>

<style scoped lang="scss">
.width70px {
  width: 70px;
}
.margin-left {
  margin-left: 30px !important;
}
.height200px {
  min-height: 222px;
  overflow-y: auto;
}

::v-deep .v-slide-group {
  height: 30px !important;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  display: none;
}

.textarea-input {
  font-size: 14px;
}
</style>
